var map = {
	"./backdrop.svg": "f796",
	"./cymbalLeft.svg": "7f64",
	"./cymbalLeftHit.svg": "10d6",
	"./cymbalRight.svg": "b307",
	"./cymbalRightHit.svg": "36f5",
	"./highHat.svg": "6b41",
	"./highHatHit.svg": "8210",
	"./kickDrum.svg": "fd8c",
	"./kickDrumHit.svg": "7f07",
	"./snare.svg": "56dd",
	"./snareHit.svg": "efd4",
	"./tomLarge.svg": "63a6",
	"./tomLargeHit.svg": "86cc",
	"./tomMid.svg": "21c7a",
	"./tomMidHit.svg": "a527",
	"./tomSmall.svg": "d4d5",
	"./tomSmallHit.svg": "0ed4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9026";